import { isEqual } from 'lodash-es';
import { Observable, distinctUntilChanged } from 'rxjs';

export const distinctUntilObjectChanged =
  <T>() =>
  (source: Observable<T>) =>
    source.pipe(distinctUntilChanged((prev, curr) => isEqual(prev, curr)));
